export const CheckTaskIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group">
      <path
        id="Vector"
        d="M10.0002 15.672L19.1922 6.479L20.6072 7.893L10.0002 18.5L3.63623 12.136L5.05023 10.722L10.0002 15.672Z"
        fill="#4CAF50"
      />
    </g>
  </svg>
);
